import { render, staticRenderFns } from "./Compy.vue?vue&type=template&id=c6b70940&scoped=true&"
import script from "./Compy.vue?vue&type=script&lang=js&"
export * from "./Compy.vue?vue&type=script&lang=js&"
import style0 from "./Compy.vue?vue&type=style&index=0&id=c6b70940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b70940",
  null
  
)

export default component.exports